import axios from 'axios'
import { services } from '@billow/js-helpers'
import { store } from '@/store'
import { router } from '@/routing'
import qs from 'qs'
import omitBy from 'lodash/omitBy'

let baseURL = process.env.VUE_APP_BASE_URL

export let http = axios.create({
  baseURL,
  paramsSerializer: params => {
    let queryString = qs.stringify(omitBy(params, value => {
      return value === '' || value === null
    }), {
      arrayFormat: 'brackets'
    })
    return queryString || ''
  },
});

http.interceptors.request.use(config => {
  Object.assign(config.headers, services.auth.authHeaders())
  return config
})

http.interceptors.response.use(response => {
  if (response.status === 200 || response.status === 201) store.commit('billow/error/clear')
  return response
}, error => {
  if (error.response && error.response.status === 422) store.commit('billow/error/set', error.response.data)

  if (error.response && error.response.status === 401) {
    store.dispatch('auth/logout')
    if (!['reset-password', 'forgot-password'].includes(router.history.current.name)) {
      router.push({ name: 'login' })
    }
  }
  return Promise.reject(error)
});

export let get = (url, success, failure, options = {}) => {
  return http.get(url, {
    params: options.params
  })
    .then(response => success(response))
    .catch(error => failure(error))
}

export let download = (url, success, failure, options = {}) => {
  return http.get(url, {
    params: options.params,
    responseType: 'blob'
  })
    .then(response => success(response))
    .catch(error => failure(error))
}

export let post = (url, data, success, failure) => {
  return http.post(url, data)
    .then(response => success(response))
    .catch(error => failure(error))
}

export default {
  get,
  post,
  download
}
